import ColorAttributeValueValidator from "./ColorAttributeValueValidator.js";
export default {
  install(molten) {
    molten.addPlugin('AttributeValueValidator', {
      name: 'location.farFromSiteThreshold',
      objectType: 'location',
      valueValidator: (valObject, ...rest) => {
        if (valObject?.value == null) {
          return true;
        }
        const {
          value
        } = valObject;
        if (typeof value !== 'number' || value < 0.5) {
          return 'Value must be a number greater than or equal to 0.5';
        }
        return true;
      }
    });
    molten.addPlugin('AttributeValueValidator', {
      name: 'assetLocators.color',
      objectType: 'assetLocators',
      valueValidator: ColorAttributeValueValidator
    });
  }
};